import {useState} from "react";
import {useFormik} from "formik";
import {message} from "antd";
import {useStore} from "../../../../../hooks/useStore";
import config from "../../../../../_core/config";
import moment from "moment";

export const useCourierWalletSettings = ({
    courier,
    courierLoading = true,
    reloadCourier = () => {}
}) => {
    const [creditLogCalculationLoading, setCreditLogCalculationLoading] = useState(false);

    const stores = useStore();
    const formik = useFormik({
        initialValues: {
            isWalletActive: Boolean(courier?.isWalletActive),
            startDepositAmount: undefined,
            blockedBalance: config.defaultBlockedCourierBalance
        },
        enableReinitialize: true,
        onSubmit: async (values, {setSubmitting}) => {
            try {
                const result = await stores.walletStore.createAndActivateCourierWallet({
                    courierId: courier?._id,
                    startDepositAmount: values.startDepositAmount,
                    blockedBalance: values.blockedBalance
                });
                if (!result) {
                    throw new Error("Cüzdan oluşturulurken bir hata oluştu");
                } else {
                    message.success("Cüzdan başarıyla oluşturuldu ve aktif edildi");
                    reloadCourier();
                }
            } catch (error) {
                message.error(error?.message || "Cüzdan oluşturulurken bir hata oluştu");
            } finally {
                setSubmitting(false);
            }
        }
    });

    const isWalletActive = () => Boolean(courier?.isWalletActive);
    const courierDataValid = () => Boolean(courier?.iban && courier?.taxNumber);
    const isStartDepositAmountCalculated = () => formik.values.startDepositAmount !== undefined;
    const calculateCourierCreditLogSummary = async date => {
        try {
            if (!date) {
                return;
            }
            setCreditLogCalculationLoading(true);
            const startDate = date
                ? moment(date)
                      .startOf("day")
                      .format("YYYY-MM-DD")
                : null;
            const startTime = date ? moment(date).format("HH:mm") : null;
            const result = await stores.walletStore.getCourierCreditLogSummary({
                courierId: courier?._id,
                startDate,
                startTime
            });
            if (!result) {
                setCreditLogCalculationLoading(false);
                return;
            }

            formik.setFieldValue("startDepositAmount", result.totalCreditAmount).then(() => {
                setCreditLogCalculationLoading(false);
            });
        } catch (error) {
            console.log(error);
        }
    };

    const isButtonDisabled =
        courierLoading ||
        !courierDataValid() ||
        isWalletActive() ||
        !isStartDepositAmountCalculated() ||
        !stores.meStore.checkRole("createWallet");

    return {
        isWalletActive,
        courierDataValid,
        isStartDepositAmountCalculated,
        calculateCourierCreditLogSummary,
        creditLogCalculationLoading,
        isButtonDisabled,
        formik
    };
};
